import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { StyleProvider } from '@ant-design/cssinjs';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './components/Dashboard';
import UserManagement from './components/UserManagement';
import Login from './components/Login';
import Unauthorized from './components/Unauthorized';
import NotFoundPage from './components/NotFoundPage';

import customTheme from './theme.json';

const App: React.FC = () => {
  return (
    <StyleProvider>
      <ConfigProvider theme={customTheme}>
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute
                  requiredPermissions={['manage_users', 'view_user_profiles']}
                  element={<Dashboard />}
                />
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute
                  requiredPermissions={['manage_users', 'view_user_profiles']}
                  element={<UserManagement />}
                />
              }
            />
            <Route path="/login" element={<Login />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Router>
      </ConfigProvider>
    </StyleProvider>
  );
};

export default App;






